<template>
  <div class="merchant-select" @click="getMerchants">
    <model-select
      id="merchant"
      v-model="merchant"
      :options="merchants"
      :placeholder="currentMerchant"
      @input="merchantInput($event)"
    />
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import endpoints from '@/utils/endpoints.js'

export default {
  components: {
    ModelSelect
  },
  data() {
    return {
      merchant: { value: {}, text: '' },
      merchants: []
    }
  },
  methods: {
    getMerchants() {
      new Promise((resolve, reject) => {
        setTimeout(() => {
          this.axios
            .get(endpoints.listMerchantOrganizations(), {
              params: { page: 1, page_size: 10000 }
            })
            .then(res => {
              let results = []
              for (const merchant of res.data.results) {
                results.push({ value: merchant, text: merchant.name })
              }
              resolve(results)
            })
            .catch(err => {
              console.log('error', err)
              reject(err)
            })
        }, 100)
      }).then(response => {
        this.merchants = response
      })
    },
    merchantInput(event) {
      if (this.merchant.value) {
        this.$store.dispatch('getMerchant', {
          merchantID: this.merchant.value.id
        })

        if (this.$router?.currentRoute?.name != 'Home') {
          this.$router.push({ name: 'Home' })
        }
      }
    }
  },
  computed: {
    currentMerchant() {
      return this.$store.getters.currentMerchant?.name
    }
  }
}
</script>

<style lang="scss" scoped>
.merchant-select {
  width: 200px;
}
</style>
